export default "__VITE_ASSET__4c9dd982__"